// Check if we're in development mode without AWS services
const isDevelopmentMode = process.env.REACT_APP_DEVELOPMENT_MODE === 'true';
const skipAwsConfig = process.env.REACT_APP_SKIP_AWS_CONFIG === 'true';

const awsConfig = skipAwsConfig ? {} : {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_OAUTH_DOMAIN || '',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [window.location.origin + '/callback'],
          redirectSignOut: [window.location.origin + '/logout'],
          responseType: 'code' as const,
        },
      },
    },
  },
  API: {
    REST: {
      'outlook-assistant-api': {
        endpoint: process.env.REACT_APP_API_ENDPOINT || '',
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      },
    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_S3_BUCKET || '',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    },
  },
};

export default awsConfig;
export { isDevelopmentMode, skipAwsConfig };